module.exports = __webpack_public_path__ + "static/b-a-3-after-44b83cc05a2ee6266509934394481c0e.jpg";